import React, {Component} from 'react';
import { connect } from 'react-redux';
import Grid from '@react/react-spectrum/Grid/js/Grid';
import GridColumn from '@react/react-spectrum/Grid/js/GridColumn';
import GridRow from '@react/react-spectrum/Grid/js/GridRow';
import Heading from '@react/react-spectrum/Heading/js/Heading';
import { Translate } from 'react-redux-i18n';
import Button from '@react/react-spectrum/Button';
import { CONTACT_HELPDESK } from '../config/constants';

class NonPartnerAccount extends Component{ 
    
    render(){
        return <div>
            <Grid>  
                <GridRow>
                    <GridColumn size={[12,8,6,6]} offsetSize={[0,2,3,3]}>
                        <Heading className = "textBold dark padding-5" variant="pageTitle"><Translate value="registration.problem_header"/></Heading>
                        <GridRow className="padding-3 font">
                            <GridColumn  >
                            {/*The Adobe ID you've signed in with (<b>{this.props.profile.email}</b>) exist in a non partner account.
                            You can sign in with another Adobe ID, or contact the helpdesk to continue your registration.  //check*/}
                            <Translate value="registration.account_not_found" email={this.props.profile.email} />
                            </GridColumn>
                        </GridRow>
                        <GridRow className="padding-3">
                            <GridColumn>
                                <Button variant="cta" onClick={()=>{
                                    window.adobeIMS.signOut();
                                }
                                }><Translate value="registration.sign_in"/></Button>
                                <Button variant="primary" onClick={()=>{
                                    window.open(CONTACT_HELPDESK,"_blank");
                                }
                                }><Translate value="registration.Contact Helpdesk" /></Button>
                            </GridColumn>
                            </GridRow>
                    </GridColumn>
                </GridRow>
            </Grid>
            </div>
    }
}

const mapStateToProps = (state) => ({
  profile: state.ims.userProfile,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(NonPartnerAccount);